import React, { HTMLAttributes } from 'react'

import { Item } from '@frame/lib/hooks/useGetItems'

import { SearchResult } from './search-result'

type Props = {
  item: Item
  showImage?: boolean
  className?: HTMLAttributes<HTMLElement>['className']
  handleSelect: () => void
}

export function LinkItem({ item, showImage, className, handleSelect }: Props) {
  return (
    <SearchResult
      name={item.name}
      detail={item.detail}
      imageUrl={item.logo_url}
      showImage={showImage}
      handleSelect={handleSelect}
      className={className}
    />
  )
}
